import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
  selector: 'ppl-spending-plan-detailed-summary',
  standalone: true,
  imports: [NzGridModule, CommonModule],
  templateUrl: './spending-plan-detailed-summary.component.html',
  styleUrl: './spending-plan-detailed-summary.component.css'
})
export class SpendingPlanDetailedSummaryComponent {
  @Input() chartSummary: any;

  constructor(){}

  ngOnInit(){
  }
}
